import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getAdminTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      profile_settings: {
        tabs: {
          main: {
            tab_name: 'MAIN_TAB_NAME',
            name: 'MAIN_NAME',
            telegram: 'MAIN_TELEGRAM',
            ms_teams: 'MAIN_MS_TEAMS',
            whatsapp: 'MAIN_WHATSAPP',
          },
          email: {
            tab_name: 'EMAIL_TAB_NAME',
            current_email: 'EMAIL_CURRENT_EMAIL',
            unconfirmed_email: 'EMAIL_UNCONFIRMED_EMAIL',
            current_password: 'EMAIL_CURRENT_PASSWORD',
          },
          password: {
            tab_name: 'PASSWORD_TAB_NAME',
            password: 'PASSWORD_PASSWORD',
            password_confirmation: 'PASSWORD_PASSWORD_CONFIRMATION',
            current_password: 'PASSWORD_CURRENT_PASSWORD',
          },
          confirmation_email: {
            tab_name: 'CONFIRMATION_TAB_NAME',
            token: 'CONFIRMATION_TOKEN',
            check_mailbox_message: 'CHECK_MAILBOX_MESSAGE',
          },
          two_factor_authentication: {
            tab_name: 'TFA_TAB_NAME',
            current_password: 'TFA_CURRENT_PASSWORD',
            secret_value: 'TFA_SECRET_VALUE',
            enter_mfa_code_for_disable: 'TFA_ENTER_CODE_FOR_DISABLE',
            enter_mfa_code_for_enable: 'TFA_ENTER_CODE_FOR_ENABLE',
            two_factor_auth_enabled: 'TFA_ENABLED',
            two_factor_auth_disabled: 'TFA_DISABLED',
          },
        },
        main_title: 'HEADER',
        save: 'SAVE',
        back: 'BACK',
      },
    },
  }));
}

export function getAffiliateTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    affiliate: {
      profile_settings: {
        header: 'HEADER',
        save: 'SAVE',
        tabs: {
          main: {
            tab_name: 'MAIN_TAB_NAME',
            name: 'MAIN_NAME',
            surname: 'MAIN_SURNAME',
            username: 'MAIN_USERNAME',
            telegram: 'MAIN_TELEGRAM',
            ms_teams: 'MAIN_MS_TEAMS',
            whatsapp: 'MAIN_WHATSAPP',
            birthday: 'MAIN_BIRTHDAY',
            phone_number: 'MAIN_PHONE_NUMBER',
            site_url: 'MAIN_SITE_URL',
            about_affiliate: 'MAIN_ABOUT_AFFILIATE',
            agree_receive_emails: 'MAIN_AGREE_RECEIVE_EMAILS',
          },
          email: {
            tab_name: 'EMAIL_TAB_NAME',
            email: 'EMAIL_EMAIL',
            unconfirmed_email: 'EMAIL_UNCONFIRMED_EMAIL',
            current_email: 'EMAIL_CURRENT_EMAIL',
            current_password: 'EMAIL_CURRENT_PASSWORD',
          },
          password: {
            tab_name: 'PASSWORD_TAB_NAME',
            password: 'PASSWORD_PASSWORD',
            password_confirmation: 'PASSWORD_PASSWORD_CONFIRMATION',
            current_password: 'PASSWORD_CURRENT_PASSWORD',
          },
          confirmation_email: {
            tab_name: 'CONFIRMATION_TAB_NAME',
            token: 'CONFIRMATION_TOKEN',
            check_mailbox_message: 'CHECK_MAILBOX_MESSAGE',
          },
          two_factor_authentication: {
            tab_name: 'TFA_TAB_NAME',
            current_password: 'TFA_CURRENT_PASSWORD',
            secret_value: 'TFA_SECRET_VALUE',
            enter_mfa_code_for_disable: 'TFA_ENTER_CODE_FOR_DISABLE',
            enter_mfa_code_for_enable: 'TFA_ENTER_CODE_FOR_ENABLE',
            two_factor_auth_enabled: 'TFA_ENABLED',
            two_factor_auth_disabled: 'TFA_DISABLED',
          },
          payment_systems: {
            tab_name: 'PAYMENT_SYSTEMS_TAB_NAME',
          },
        },
      },
    },
  }));
}
